export const CITIES = { brno: "brno", praha: "praha" };

export type TCity = keyof typeof CITIES;
